import { computed, inject } from 'vue'
import type { Ref } from 'vue'

export const BOARD_TRAVEL_KEY = Symbol('boardTravel')
export const BOARD_FILTERS_KEY = Symbol('boardFilters')

export function useBoardFilters(options?: {
  applyStatus?: boolean
  applyOrganisateurs?: boolean
  applyCompanions?: boolean,
  applyTransport?: boolean,
  applyTransfert?: boolean,
  applyHotelRoom?: boolean
}) {
  const applyStatus = options?.applyStatus ?? true
  const applyOrganisateurs = options?.applyOrganisateurs ?? true
  const applyCompanions = options?.applyCompanions ?? true
  const applyTransport = options?.applyTransport ?? true
  const applyTransfert = options?.applyTransfert ?? true
  const applyHotelRoom = options?.applyHotelRoom ?? true

  const travel = inject<Ref<AdminTravel>>(BOARD_TRAVEL_KEY)
  const filters = inject<Ref<BoardFilters>>(BOARD_FILTERS_KEY)

  const participations = computed(() => {
    const all = travel?.value?.participations ?? []

    const hotelRoomIds = filters?.value.hotelRoomByName?.label ?
    travel?.value?.hotels?.flatMap(x => x.quotaGroups ?? []).flatMap(x => x.rooms ?? []).filter(x=>x.name == filters.value.hotelRoomByName!.label).map(x => x.id) ?? []
    : null;

    return all.filter(p => {
      if (applyStatus && filters?.value && filters.value.statusFilter !== 'all') {
        const isInscrit = !!p.invitation?.completionDate && !p.invitation?.refusalDate
        const isAbsent = !!p.invitation?.refusalDate && !p.invitation?.completionDate
        const isNonInscrit = !p.invitation?.completionDate && !p.invitation?.refusalDate

        if (filters.value.statusFilter === 'inscrit' && !isInscrit) return false
        if (filters.value.statusFilter === 'absent' && !isAbsent) return false
        if (filters.value.statusFilter === 'non-inscrit' && !isNonInscrit) return false
      }

      if (applyOrganisateurs && filters?.value && filters.value.hideOrganisateurs) {
        if (p.userInfo?.status === UserStatusEnum.Organisation || (p.userInfo?.status == null && p.user?.isAdmin === true)) return false
      }

      if((applyTransport && filters?.value?.transportFilter != 'all') || (applyHotelRoom && hotelRoomIds) || (applyTransfert && filters?.value?.transfertId)) {
        if(filters?.value.statusFilter == 'all') filters.value.statusFilter = 'inscrit' // If the user has a transport filter or transport option, remove non participants (i.e. those who have not completed their invitation or have refused it)
      }

      if(applyTransport) {
        if (filters?.value && filters.value.transportFilter === 'with') {
          if (!p.travelInfo?.withPackage || p.travelInfo?.specialCase || p.travelInfo?.withoutTransport) return false
        } else if (filters?.value && filters.value.transportFilter === 'without') {
          if (p.travelInfo?.withPackage && !p.travelInfo?.withoutTransport) return false
        }


        if (filters?.value && filters.value.transportOption) {
          if (p.transportation?.optionId !== filters.value.transportOption.id) return false
        }
      }

      if(applyTransfert) {
        if (filters?.value && filters.value.transfertId) {
          if (p.transfer?.outboundTravelDbTransferId !== filters.value.transfertId.id &&
              p.transfer?.returnTravelDbTransferId !== filters.value.transfertId.id &&
              p.transfer?.roundTripTravelDbTransferId !== filters.value.transfertId.id) return false
        }
      }

      if(applyHotelRoom) {
        if (hotelRoomIds != null) {
          if (p.hotelRooms?.flatMap(x=>x).some(room => hotelRoomIds.includes(room.travelDbHotelRoomId)) === false) return false
        }
      }

      return true
    })
  })

  const companions = computed(() => {
    if(applyCompanions && (filters?.value.hideCompanions == true)) {
      return [];
    }

    return participations.value.filter(x=>x.invitation?.completionDate != null && x.invitation?.refusalDate == null).flatMap(x => x.companions ?? []) ?? [];
  });

  return { travel, filters, participations, companions }
}
